import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { Typography } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { useStyles, formControlLabelStyles, radioBtnStyles } from './styles';

const StartTimeAndDurationRadioButtonsGroup = ({
  input,
  label,
  list,
  className,
  labelClass,
  startTimeClass
}) => {
  const classes = useStyles();
  const formControlLabelClasses = formControlLabelStyles();
  const radioBtnSClasses = radioBtnStyles();
  const [t] = useTranslation();

  if (!list || !list.length) return null;

  const onChangeHandler = e => {
    const updatedItem = list.find(item => item.id === e.target.value);

    input.onChange(updatedItem);
  };

  return (
    <div className={classNames(classes.wrapper, className)}>
      <div className={classNames(classes.label, labelClass)}>{t(label)}</div>
      <RadioGroup
        aria-label="position"
        name="position"
        row
        value={input.value.id || null}
        onChange={onChangeHandler}
        className={classes.radioGroup}
      >
        {list.map((item, index) => {
          if (!item.seatsLeft) return null;
          return (
            <FormControlLabel
              classes={formControlLabelClasses}
              key={index}
              value={item.id}
              control={<Radio color="default" classes={radioBtnSClasses} />}
              label={
                <div className={classes.labelWrapper}>
                  <Typography
                    variant="h2"
                    className={classNames(
                      classes.time,
                      {
                        [classes.radioBtnLabelChecked]:
                          item.id === input.value.id
                      },
                      startTimeClass
                    )}
                  >
                    {item.startTime}
                  </Typography>
                  <Typography
                    variant="body1"
                    className={classNames(classes.seats, {
                      [classes.radioBtnLabelChecked]: item.id === input.value.id
                    })}
                  >
                    {item.seatsLeft} {t('Seats left')}
                  </Typography>
                  <Typography
                    variant="body1"
                    classes={{ root: classes.duration }}
                  >
                    {item.duration}{' '}
                    <span className={classes.capitalize}>
                      {t(item.timeType)}
                    </span>
                  </Typography>
                </div>
              }
              labelPlacement="end"
            />
          );
        })}
      </RadioGroup>
    </div>
  );
};

export default StartTimeAndDurationRadioButtonsGroup;
